exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dialog-close-button {\n  position: absolute;\n  float: right;\n  margin-bottom: -15px;\n  cursor: pointer;\n  border: 3px solid #fff;\n  background: #34495E !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-align: center !important;\n      align-items: center !important;\n  border-radius: 100% !important;\n  top: -10px !important;\n  right: -9px !important; }\n\n.dialog-close-button svg {\n  fill: #fff !important;\n  padding: 5px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Dialog/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Dialog/index.css
// module chunks = 504